import React, { useEffect, useState } from 'react';
interface SaleData {
  name: string;
  location: string;
  price: number;
}
const salesData: SaleData[] = [{
  name: 'María',
  location: 'Miami',
  price: 47
}, {
  name: 'Carmen',
  location: 'Los Angeles',
  price: 47
}, {
  name: 'Rosa',
  location: 'Houston',
  price: 47
}, {
  name: 'Ana',
  location: 'Chicago',
  price: 11.97
}, {
  name: 'Sofia',
  location: 'Phoenix',
  price: 47
}, {
  name: 'Isabella',
  location: 'San Antonio',
  price: 47
}, {
  name: 'Valentina',
  location: 'Dallas',
  price: 47
}, {
  name: 'Camila',
  location: 'San Diego',
  price: 11.97
}, {
  name: 'Lucia',
  location: 'Austin',
  price: 47
}, {
  name: 'Elena',
  location: 'San Jose',
  price: 47
}];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState<SaleData>(salesData[0]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    // Check if mobile viewport
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    if (!isMobile) return;
    const showNotification = () => {
      // Pick random sale
      const randomSale = salesData[Math.floor(Math.random() * salesData.length)];
      setCurrentSale(randomSale);
      // Show notification
      setIsVisible(true);
      // Hide after 3 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    };
    // Initial delay before first notification
    const initialTimeout = setTimeout(showNotification, 2000);
    // Loop: show for 3s, hide for 3s
    const interval = setInterval(showNotification, 6000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isMobile]);
  if (!isMobile) return null;
  return <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} style={{
    animation: isVisible ? 'bounce-in 0.5s ease-out' : 'none'
  }} data-id="element-90">
      <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl p-3 flex items-center gap-3 max-w-[340px] border border-gray-200/50" data-id="element-91">
        {/* Product Image */}
        <div className="flex-shrink-0" data-id="element-92">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1ijejMRnwm7RVrEqfusc1u/secretos-abuela-fondo-crema.png" alt="Los Secretos de la Abuela" className="w-12 h-12 rounded-lg object-cover" data-id="element-93" />
        </div>

        {/* Sale Info */}
        <div className="flex-1 min-w-0" data-id="element-94">
          <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-95">
            {currentSale.name} de {currentSale.location}
          </p>
          <p className="text-xs text-gray-600 truncate" data-id="element-96">
            compró{' '}
            <span className="font-medium" data-id="element-97">Los Secretos de la Abuela</span>
          </p>
          <p className="text-sm font-bold text-[#D4AF37] mt-0.5" data-id="element-98">
            ${currentSale.price}
          </p>
        </div>
      </div>

      <style jsx data-id="element-99">{`
        @keyframes bounce-in {
          0% {
            transform: translateY(100%) translateX(-50%);
            opacity: 0;
          }
          50% {
            transform: translateY(-10px) translateX(-50%);
          }
          100% {
            transform: translateY(0) translateX(-50%);
            opacity: 1;
          }
        }
      `}</style>
    </div>;
}